import React from "react";
import {
    Card,
    CardBody,
    Button
} from "reactstrap";
import {
    Award,
    CheckCircle
} from "react-feather";

const CompletedScreen = () => {

    return (

        <Card className="border-0 shadow">

            <CardBody className="text-center py-5">

                <div
                    className="rounded-circle bg-success text-white d-inline-flex justify-content-center align-items-center"
                    style={{
                        width: 100,
                        height: 100
                    }}
                >

                    <Award size={48} />

                </div>

                <h2 className="fw-bold mt-4">

                    Interactive FAQ Completed

                </h2>

                <p className="text-muted mt-3">

                    Thank you for participating.

                    <br />

                    All your responses have been saved successfully.

                </p>

                <Button
                    color="success"
                    size="lg"
                    disabled
                >

                    <CheckCircle
                        size={18}
                        className="me-2"
                    />

                    Session Completed

                </Button>

            </CardBody>

        </Card>

    );

};

export default CompletedScreen;